/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from 'store/mutation-types';

const state = {
  session: {},
  error: null,
};

const getters = {
  session: state => state.session,
  error: state => state.error,
};

const actions = {
  fetch({ commit }, payload) {
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/parking/session/${payload.id}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      }).catch((response) => {
        commit(mTypes.DATA_ERROR, response.body.error);
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, parking) {
    state.session = parking.data;
    state.error = null;
  },
  [mTypes.DATA_ERROR](state, error) {
    state.error = true;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/parkings/session.js